module.exports = __webpack_public_path__ + "static/illuFeedback-a619a691c49960d780ab0263c71d73da.jpg";